module.exports = ".footer{    \r\n    font-size: 10pt;\r\n    color: #9a9c9b;\r\n    /* margin-right: 67px;\r\n    margin-top: 218px;\r\n    position: fixed;\r\n    margin-left: 900px; */\r\n    float: right;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common-footer/common-footer.component.css
// module id = ./src/app/components/common-footer/common-footer.component.css
// module chunks = main